var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { useUpdateMarketingPushAgreement } from '@/utils/marketingPushAgreement';
import BottomSheet from './BottomSheet';
import BottomSheetButtonGroup, { BottomSheetButtonGroupLayout, } from './BottomSheet/BottomSheetButtonGroup';
// 배경 탭으로는 닫히지 않는다(onPressBackground 미지정). 어느 버튼이든 응답해야 닫힌다.
// 실패해도 닫는다 — 다음 홈 진입 때 서버가 needs=true 를 다시 준다.
const MarketingPushAgreementBottomSheet = ({ isVisible, onClose }) => {
    const updateAgreement = useUpdateMarketingPushAgreement();
    const respond = (isAgreed) => __awaiter(void 0, void 0, void 0, function* () {
        yield updateAgreement(isAgreed);
        onClose();
    });
    return (_jsxs(BottomSheet, { isVisible: isVisible, children: [_jsxs(ContentsContainer, { children: [_jsx(Title, { children: "\uD61C\uD0DD\u00B7\uC18C\uC2DD \uC54C\uB9BC\uC744 \uBC1B\uC544\uBCF4\uC2DC\uACA0\uC5B4\uC694?" }), _jsx(Message, { children: "\uACC4\uB2E8\uBFCC\uC154\uD074\uB7FD\uC774 \uC18C\uAC1C\uD558\uB294 \uCF58\uD150\uCE20\uB098 \uC774\uBCA4\uD2B8 \uAC19\uC740 \uB9C8\uCF00\uD305 \uC815\uBCF4\uB97C \uD478\uC2DC \uC54C\uB9BC\uC73C\uB85C \uBCF4\uB0B4\uB4DC\uB824\uC694. \uBA54\uB274 > \uC124\uC815\uC5D0\uC11C \uC5B8\uC81C\uB4E0 \uBC14\uAFC0 \uC218 \uC788\uC5B4\uC694." })] }), _jsx(BottomSheetButtonGroup, { layout: BottomSheetButtonGroupLayout.HORIZONTAL_1X2, positiveButton: { text: '알림 받기', onPressed: () => respond(true) }, negativeButton: { text: '괜찮아요', onPressed: () => respond(false) } })] }));
};
export default MarketingPushAgreementBottomSheet;
const ContentsContainer = styled.View({
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 28,
    paddingHorizontal: 20,
});
const Title = styled.Text({
    width: '100%',
    color: color.black,
    fontSize: 20,
    fontFamily: font.pretendardBold,
    marginTop: 10,
    marginBottom: 10,
});
const Message = styled.Text({
    width: '100%',
    color: color.black,
    fontSize: 16,
    fontFamily: font.pretendardRegular,
});
